import { palette } from 'main/ui'
import { TFunction } from 'react-i18next'

export function philosophyColor(philosophy: string) {
  switch (philosophy) {
    case 'play_based':
      return palette.skyBlue2
    case 'montessori':
    case 'montessori_inspired':
      return palette.lavender2
    case 'reggio_emilia_inspired':
    case 'rie_inspired':
      return palette.goldenrod2
    case 'waldorf':
    case 'waldorf_inspired':
      return palette.tangerine2
    case 'nature_based':
      return palette.fern2
    case 'stem':
    case 'steam':
      return palette.rose2
    case 'bilingual':
    case 'language_immersion':
    case 'hidden':
      return palette.slate
    default:
      throw new Error(`unsupported philosophy: ${philosophy}`)
  }
}

export function philosophyColorKey(philosophy: string) {
  switch (philosophy) {
    case 'play_based':
      return PhilosophyColor.Skyblue
    case 'montessori':
    case 'montessori_inspired':
      return PhilosophyColor.Lavender
    case 'reggio_emilia_inspired':
    case 'rie_inspired':
      return PhilosophyColor.Goldenrod
    case 'waldorf':
    case 'waldorf_inspired':
      return PhilosophyColor.Tangerine
    case 'nature_based':
      return PhilosophyColor.Fern
    case 'stem':
    case 'steam':
      return PhilosophyColor.Rose
    case 'bilingual':
    case 'language_immersion':
    case 'hidden':
      return PhilosophyColor.Slate
    default:
      throw new Error(`unsupported philosophy: ${philosophy}`)
  }
}

export enum PhilosophyColor {
  Fern = 'fern',
  Goldenrod = 'goldenrod',
  Lavender = 'lavender',
  Rose = 'rose',
  Skyblue = 'skyblue',
  Slate = 'slate',
  Tangerine = 'tangerine',
}

const PRE = `COMPONENTS-SCHOOL-BASICS-PHILOSOPHY`

export function philosophyLabelTranslated(key: string, t: TFunction) {
  switch (key) {
    case 'play_based':
      return t(`${PRE}-PLAY-BASED`)
    case 'montessori':
      return t(`${PRE}-MONTESSORI`)
    case 'montessori_inspired':
      return t(`${PRE}-MONTESSORI-INSPIRED`)
    case 'reggio_emilia_inspired':
      return t(`${PRE}-REGGIO-EMILIA-INSPIRED`)
    case 'rie_inspired':
      return t(`${PRE}-RIE-INSPIRED`)
    case 'waldorf':
      return t(`${PRE}-WALDORF`)
    case 'waldorf_inspired':
      return t(`${PRE}-WALDORF-INSPIRED`)
    case 'nature_based':
      return t(`${PRE}-NATURE-BASED`)
    case 'stem':
      return t(`${PRE}-STEM`)
    case 'steam':
      return t(`${PRE}-STEAM`)
    case 'bilingual':
      return t(`${PRE}-BILINGUAL`)
    case 'language_immersion':
      return t(`${PRE}-LANGUAGE-IMMERSION`)
    case 'hidden':
      return t(`${PRE}-HIDDEN`)
    default:
      throw new Error(`unsupported philosophy: ${key}`)
  }
}

export function philosophyLabel(philosophy: string) {
  switch (philosophy) {
    case 'play_based':
      return 'Play Based'
    case 'montessori':
      return 'Montessori'
    case 'montessori_inspired':
      return 'Montessori Inspired'
    case 'reggio_emilia_inspired':
      return 'Reggio Emilia Inspired'
    case 'rie_inspired':
      return 'RIE Inspired'
    case 'waldorf':
      return 'Waldorf'
    case 'waldorf_inspired':
      return 'Waldorf Inspired'
    case 'nature_based':
      return 'Nature Based'
    case 'stem':
      return 'STEM'
    case 'steam':
      return 'STEAM'
    case 'bilingual':
      return 'Bilingual'
    case 'language_immersion':
      return 'Language Immersion'
    case 'hidden':
      return 'Hidden'
    default:
      throw new Error(`unsupported philosophy: ${philosophy}`)
  }
}
